/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { ConfigurationVariables } from "../config";

import { getBearerToken, getIAMProjectID } from "../utils/utility";
import { AD_ORGANIZATION_ID, RBM_ACCESS_TOKEN_STORAGE_NAME } from "../utils/constants";

export const remoteConnectAPI = createApi({
	reducerPath: "remoteConnectAPI",
	baseQuery: fetchBaseQuery({
		baseUrl: ConfigurationVariables.API_BASE_HOST_URL,
		prepareHeaders: async (headers) => {
			try {
				headers.set("authorization", await getBearerToken(RBM_ACCESS_TOKEN_STORAGE_NAME));
				headers.set("organizationId", AD_ORGANIZATION_ID);
				headers.set("IAM-ProjectId", getIAMProjectID());
			} catch (error) {
				console.error(error);
			}

            return headers;
        }
    }),
    endpoints: (builder) => ({
        getLinkedDevicesList: builder.query({
            query: ({ gatewayId }) => ({
                url: `/v2/projects/${getIAMProjectID()}/gateway/${gatewayId}/devices`,
                
            }),
            keepUnusedDataFor: 0
        }),
        getDownloadClient: builder.query({
            query: () => ({
                url: `/v2/projects/${getIAMProjectID()}/remote/client`,
                responseHandler: (response) => response.blob() // Specify response type as blob
            })
        }),
        addPortGateway: builder.mutation({
            query: ({ gatewayId, payload }) => ({
                url: `/v2/projects/${getIAMProjectID()}/gateway/${gatewayId}`,
                method: "POST",
                body: payload
            })
        }),
        addPortDevice: builder.mutation({
            query: ({ deviceId, gatewayId, payload }) => ({
                url: `/v2/projects/${getIAMProjectID()}/gateway/${gatewayId}/device/${deviceId}`,
                method: "POST",
                body: payload

			})
		}),
		getGatewayConnectivityDetails: builder.query({
			query: ({ gatewayId }) => ({
				url: `/v2/projects/${getIAMProjectID()}/gateway/${gatewayId}/connection/details`,
               
			}),
             keepUnusedDataFor: 0
		}),

        removePortDevice: builder.mutation({
            query: ({ deviceId, gatewayId }) => ({
                url: `/v2/projects/${getIAMProjectID()}/gateway/${gatewayId}/device/${deviceId}`,
                method: "DELETE"
            })
        }),
        getActiveConnectionUserDetails: builder.query({
            query: ({ gatewayId }) => ({
                url: `/v2/projects/${getIAMProjectID()}/gateway/${gatewayId}/connection/users`,
                
            }),
            keepUnusedDataFor: 0
        }),
        approveOrBlockDevice: builder.mutation({
            query: ({ deviceId, gatewayId, payload }) => ({
                url: `/v2/projects/${getIAMProjectID()}/gateway/${gatewayId}/device/${deviceId}/trust`,
                method: "PUT",
                body: payload
            })
        })
    })
});

export const {
    useGetLinkedDevicesListQuery,
    useGetDownloadClientQuery,
    useAddPortGatewayMutation,
    useAddPortDeviceMutation,
    useGetGatewayConnectivityDetailsQuery,
    useRemovePortDeviceMutation,
    useGetActiveConnectionUserDetailsQuery,
    useApproveOrBlockDeviceMutation
} = remoteConnectAPI;